var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3162 20.8946C12.111 20.963 11.889 20.963 11.6838 20.8946L9.9237 20.3079C9.3119 20.104 8.67123 20 8.02633 20H4.5C3.11929 20 2 18.8807 2 17.5V6.5C2 5.11929 3.11929 4 4.5 4H9.5C10.5435 4 11.4625 4.53276 12 5.34111C12.5375 4.53276 13.4565 4 14.5 4H19.5C20.8807 4 22 5.11929 22 6.5V17.5C22 18.8807 20.8807 20 19.5 20H15.9737C15.3288 20 14.6881 20.104 14.0763 20.3079L12.3162 20.8946ZM4.5 5H9.5C10.6046 5 11.5 5.89543 11.5 7V19.7639L11.4934 19.7771L10.2399 19.3592C9.52616 19.1213 8.77871 19 8.02633 19H4.5C3.67157 19 3 18.3284 3 17.5V6.5C3 5.67157 3.67157 5 4.5 5ZM12.5 19.7639L12.5066 19.7771L13.7601 19.3592C14.4738 19.1213 15.2213 19 15.9737 19H19.5C20.3284 19 21 18.3284 21 17.5V6.5C21 5.67157 20.3284 5 19.5 5H14.5C13.3954 5 12.5 5.89543 12.5 7V19.7639Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.18bab63cf19af5b5c772d84d204100d1.svg";
export { ForwardRef as ReactComponent };